"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7343],{

/***/ 17343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_switch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/provider.js + 8 modules
var provider = __webpack_require__(64720);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(64593);
// EXTERNAL MODULE: ./src/redux/action/auth.js
var auth = __webpack_require__(38006);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/teams.js
var teams = __webpack_require__(81061);
// EXTERNAL MODULE: ./src/theme/loader/index.js
var loader = __webpack_require__(23856);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./src/theme/layouts/body.js
var body = __webpack_require__(89129);
// EXTERNAL MODULE: ./src/theme/header/index.js + 1 modules
var header = __webpack_require__(28116);
// EXTERNAL MODULE: ./src/theme/card/index.js
var card = __webpack_require__(16850);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/logo/index.js
var logo = __webpack_require__(12648);
// EXTERNAL MODULE: ./src/theme/icons/alert-rhombus.js
var alert_rhombus = __webpack_require__(47577);
;// CONCATENATED MODULE: ./src/theme/disabled/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  width: 100%;\n  min-height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b51e3450-0"
})(_templateObject(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh);
var WrapLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b51e3450-1"
})(_templateObject1(), index_esm/* space */.Dh);
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b51e3450-2"
})(_templateObject2());
var WrapLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b51e3450-3"
})(_templateObject3(), index_esm/* color */.$_);
function Disabled() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                bg: "primary_50",
                height: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                bg: "white",
                title: translations/* default */.Z[languageCode]["Profile Title"],
                style: {
                    bg: "white",
                    borderWidth: "0",
                    borderBottomWidth: "1px",
                    borderColor: "primary_200",
                    borderStyle: "solid"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLogo, {
                my: "xxl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* TwoTone */.BI, {
                    height: 48
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                width: "100%",
                maxWidth: "420px",
                bg: "white",
                borderColor: "primary_200",
                px: "m",
                py: "l",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLoader, {
                            color: "primary_200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_rhombus/* default */.Z, {
                                width: "56"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "h2",
                            lineHeight: "h2",
                            fontWeight: "bold",
                            color: "grey_600",
                            mt: "m",
                            children: translations/* default */.Z[languageCode]["Account Disabled"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "normal",
                            color: "grey_600",
                            mt: "xs",
                            textAlign: "center",
                            children: translations/* default */.Z[languageCode]["contact support"]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var disabled = (Disabled);

;// CONCATENATED MODULE: ./src/theme/not-allowed/index.js

function not_allowed_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  width: 100%;\n  min-height: 100%;\n"
    ]);
    not_allowed_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function not_allowed_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    not_allowed_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function not_allowed_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    not_allowed_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function not_allowed_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    not_allowed_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var not_allowed_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8af9e33-0"
})(not_allowed_templateObject(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh);
var not_allowed_WrapLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8af9e33-1"
})(not_allowed_templateObject1(), index_esm/* space */.Dh);
var not_allowed_Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8af9e33-2"
})(not_allowed_templateObject2());
var not_allowed_WrapLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8af9e33-3"
})(not_allowed_templateObject3(), index_esm/* color */.$_);
function NotAllowed() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(not_allowed_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                bg: "primary_50",
                height: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                bg: "white",
                title: translations/* default */.Z[languageCode]["not allowed"],
                style: {
                    bg: "white",
                    borderWidth: "0",
                    borderBottomWidth: "1px",
                    borderColor: "primary_200",
                    borderStyle: "solid"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(not_allowed_WrapLogo, {
                my: "xxl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* TwoTone */.BI, {
                    height: 48
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                width: "100%",
                maxWidth: "420px",
                bg: "white",
                borderColor: "primary_200",
                px: "m",
                py: "l",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(not_allowed_Box, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(not_allowed_WrapLoader, {
                            color: "primary_200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_rhombus/* default */.Z, {
                                width: "56"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "h2",
                            lineHeight: "h2",
                            fontWeight: "bold",
                            color: "grey_600",
                            mt: "m",
                            children: translations/* default */.Z[languageCode]["not allowed"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "normal",
                            color: "grey_600",
                            mt: "xs",
                            textAlign: "center",
                            children: translations/* default */.Z[languageCode]["not allowed description"]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var not_allowed = (NotAllowed);

// EXTERNAL MODULE: ./src/hooks/index.js
var hooks = __webpack_require__(85480);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/antd/es/badge/index.js + 4 modules
var badge = __webpack_require__(63922);
;// CONCATENATED MODULE: ./src/theme/buttons/link-menu.js



function link_menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  position: relative;\n  padding: 0;\n  background: transparent;\n  outline: 0;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  text-decoration: none;\n\n  & > span.children {\n    background: ",
        ";\n    border-radius: 8px;\n\n    ",
        "\n    ",
        "\n\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: ",
        ";\n\n    & > svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &:hover,\n  &:focus {\n    background: transparent;\n    outline: 0;\n\n    & > span.children {\n      background: ",
        ";\n      color: ",
        ";\n      outline: 0;\n    }\n\n    & > span.children > svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  & > .ant-badge {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: absolute;\n    top: -9px;\n    right: 0;\n    display: inline-block;\n    color: unset;\n    line-height: 1;\n\n    & > .ant-badge-status-dot {\n      position: relative;\n      display: inline-block;\n      width: 10px;\n      height: 10px;\n      vertical-align: middle;\n      border-radius: 50%;\n    }\n\n    & > .ant-badge-status-processing {\n      position: relative;\n      background-color: ",
        ";\n    }\n\n    & > .ant-badge-status-processing::after {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 1px solid ",
        ";\n      border-radius: 50%;\n      animation: antStatusProcessing 1.2s infinite ease-in-out;\n      content: '';\n    }\n  }\n\n  & > .ant-badge-status {\n    line-height: inherit;\n    vertical-align: baseline;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    link_menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Button = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b1b6d0f0-0"
})(link_menu_templateObject(), function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,dist_index_esm/* themeGet */.R)("colors.primary_400") : (0,dist_index_esm/* themeGet */.R)("colors.primary_500");
}, index_esm/* color */.$_, index_esm/* typography */.cp, function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,dist_index_esm/* themeGet */.R)("colors.white") : (0,dist_index_esm/* themeGet */.R)("colors.primary_200");
}, function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,dist_index_esm/* themeGet */.R)("colors.white") : (0,dist_index_esm/* themeGet */.R)("colors.primary_200");
}, (0,dist_index_esm/* themeGet */.R)("colors.primary_400"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.primary_400"), (0,dist_index_esm/* themeGet */.R)("colors.primary_400"), index_esm/* layout */.bK, index_esm/* space */.Dh);
function LinkMenu(param) {
    var title = param.title, addBadge = param.addBadge, isFocused = param.isFocused, style = param.style, children = param.children, type = param.type, href = param.href, disabled = param.disabled;
    if (href.startsWith("/")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                title: title,
                type: type,
                disabled: disabled,
                isFocused: isFocused,
                children: [
                    addBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                        status: "processing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "children",
                        children: children
                    })
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        href: href,
        title: title,
        type: type,
        disabled: disabled,
        isFocused: isFocused,
        children: [
            addBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                status: "processing"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "children",
                children: children
            })
        ]
    }));
}
/* harmony default export */ var link_menu = (LinkMenu);

;// CONCATENATED MODULE: ./src/components/btn-menu/index.js





function Btn(param) {
    var title = param.title, style = param.style, children = param.children, route = param.route;
    var router = (0,next_router.useRouter)();
    var isFocused = (0,react.useMemo)(function() {
        var basePath = router.pathname.split("/")[1];
        return route.includes("/".concat(basePath));
    }, [
        router.pathname,
        route
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_menu, {
        title: title,
        type: "button",
        isFocused: isFocused,
        style: (0,_object_spread/* default */.Z)({
            // In the drawer the entries are wide rows with room to breathe; in the
            // rail above the first breakpoint they are the squares they always were.
            width: [
                "168px",
                "76px",
                "76px",
                "100px"
            ],
            height: [
                "52px",
                "50px",
                "50px",
                "64px"
            ],
            mb: [
                "m",
                "m",
                "m",
                "m"
            ]
        }, style),
        href: route[0],
        children: children
    });
}
/* harmony default export */ var btn_menu = (Btn);

// EXTERNAL MODULE: ./src/theme/dropdown/index.js + 1 modules
var dropdown = __webpack_require__(16768);
// EXTERNAL MODULE: ./src/theme/dropdown/item/index.js
var item = __webpack_require__(63546);
;// CONCATENATED MODULE: ./src/theme/icons/burger.js


function Burger(param) {
    var _width = param.width, width = _width === void 0 ? "22" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var burger = (Burger);

// EXTERNAL MODULE: ./src/theme/icons/close.js
var icons_close = __webpack_require__(5842);
;// CONCATENATED MODULE: ./src/theme/icons/feed.js


function Feed() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16 2.40918V4.40918H12V2.40918H16ZM6 2.40918V8.40918H2V2.40918H6ZM16 10.4092V16.4092H12V10.4092H16ZM6 14.4092V16.4092H2V14.4092H6ZM18 0.40918H10V6.40918H18V0.40918ZM8 0.40918H0V10.4092H8V0.40918ZM18 8.40918H10V18.4092H18V8.40918ZM8 12.4092H0V18.4092H8V12.4092Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0.40918H18V18.4092H0V0.40918Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var feed = (Feed);

;// CONCATENATED MODULE: ./src/theme/icons/timelinechart.js


function TimelineChart() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.63636 10.9546L2.04545 11.0119L5.78455 7.27282C5.63727 6.741 5.77636 6.13554 6.21 5.71009C6.84818 5.06373 7.87909 5.06373 8.51727 5.71009C8.95091 6.13554 9.09 6.741 8.94273 7.27282L11.0455 9.37554L11.4545 9.31827C11.6018 9.31827 11.7409 9.31827 11.8636 9.37554L14.7845 6.45463C14.7273 6.33191 14.7273 6.19282 14.7273 6.04554C14.7273 5.1418 15.4599 4.40918 16.3636 4.40918C17.2674 4.40918 18 5.1418 18 6.04554C18 6.94928 17.2674 7.68191 16.3636 7.68191C16.2164 7.68191 16.0773 7.68191 15.9545 7.62463L13.0336 10.5455C13.0909 10.6683 13.0909 10.8074 13.0909 10.9546C13.0909 11.8584 12.3583 12.591 11.4545 12.591C10.5508 12.591 9.81818 11.8584 9.81818 10.9546L9.87545 10.5455L7.77273 8.44282C7.51091 8.50009 7.21636 8.50009 6.95455 8.44282L3.21545 12.1819L3.27273 12.591C3.27273 13.4947 2.5401 14.2274 1.63636 14.2274C0.732625 14.2274 0 13.4947 0 12.591C0 11.6873 0.732625 10.9546 1.63636 10.9546Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var timelinechart = (TimelineChart);

// EXTERNAL MODULE: ./src/theme/icons/card.js
var icons_card = __webpack_require__(56704);
;// CONCATENATED MODULE: ./src/theme/icons/help.js


function Help() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.89954 0C4.93694 0 0.899536 4.0374 0.899536 9C0.899536 13.9626 4.93694 18 9.89954 18C14.8621 18 18.8995 13.9626 18.8995 9C18.8995 4.0374 14.8621 0 9.89954 0ZM10.7995 14.4H8.99954V12.6H10.7995V14.4ZM11.6779 10.0035C11.5015 10.1457 11.3314 10.2816 11.1964 10.4166C10.8292 10.7829 10.8004 11.1159 10.7995 11.1303V11.25H8.99954V11.0997C8.99954 10.9935 9.02564 10.0404 9.92294 9.1431C10.0984 8.9676 10.3162 8.7894 10.5448 8.604C11.2054 8.0685 11.6392 7.6779 11.6392 7.1397C11.6288 6.68504 11.4408 6.25252 11.1155 5.93471C10.7902 5.61689 10.3534 5.43901 9.89865 5.43912C9.44386 5.43924 9.00719 5.61735 8.68206 5.93534C8.35692 6.25332 8.16916 6.68593 8.15894 7.1406H6.35894C6.35894 5.1885 7.94744 3.6 9.89954 3.6C11.8516 3.6 13.4401 5.1885 13.4401 7.1406C13.4401 8.5779 12.379 9.4356 11.6779 10.0035Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var help = (Help);

;// CONCATENATED MODULE: ./src/theme/icons/lightning.js


function Lightning(param) {
    var _color = param.color, color = _color === void 0 ? "currentColor" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "29",
        height: "28",
        viewBox: "0 0 76 76",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M27.5738 71.06C27.0877 70.8548 26.6839 70.4937 26.4258 70.0335C26.1678 69.5734 26.0703 69.0404 26.1488 68.5187L30.4713 40.375H19C18.6364 40.3848 18.2753 40.3109 17.9447 40.159C17.6141 40.0071 17.3228 39.7814 17.0933 39.4991C16.8638 39.2168 16.7023 38.8856 16.6211 38.5309C16.5399 38.1763 16.5412 37.8078 16.625 37.4537L23.75 6.57874C23.8754 6.04739 24.18 5.57544 24.6126 5.24236C25.0452 4.90928 25.5793 4.7354 26.125 4.74999H49.875C50.2298 4.74879 50.5804 4.8271 50.901 4.97916C51.2216 5.13123 51.504 5.3532 51.7275 5.62874C51.9542 5.90741 52.1147 6.23386 52.197 6.58353C52.2793 6.93321 52.2812 7.29699 52.2025 7.64749L48.0938 26.125H59.375C59.8202 26.1241 60.2566 26.2483 60.6345 26.4835C61.0124 26.7186 61.3167 27.0553 61.5125 27.455C61.6827 27.8386 61.7482 28.2605 61.7023 28.6777C61.6564 29.0949 61.5008 29.4925 61.2513 29.83L30.3763 70.205C30.1676 70.5143 29.889 70.7701 29.563 70.9517C29.237 71.1332 28.8729 71.2354 28.5 71.25C28.1823 71.2435 27.8684 71.1791 27.5738 71.06ZM42.1563 30.875L46.9063 9.49999H28.025L21.9925 35.625H36.0288L32.2525 60.04L54.625 30.875H42.1563Z",
            fill: color
        })
    });
}
/* harmony default export */ var lightning = (Lightning);

;// CONCATENATED MODULE: ./src/theme/icons/list-ul.js


function ListUl(param) {
    var _width = param.width, width = _width === void 0 ? "18" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 3.26758H3V5.26758H1V3.26758ZM1 8.26758H3V10.2676H1V8.26758ZM1 13.2676H3V15.2676H1V13.2676ZM17 5.26758V3.26758H5.023V5.26758H15.8H17ZM5 8.26758H17V10.2676H5V8.26758ZM5 13.2676H17V15.2676H5V13.2676Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var list_ul = (ListUl);

;// CONCATENATED MODULE: ./src/theme/buttons/btn-menu.js



function btn_menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 0;\n  background: transparent;\n  outline: 0;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  & > span.children {\n    background: ",
        ";\n    border-radius: 8px;\n\n    ",
        "\n    ",
        "\n\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: ",
        ";\n\n    & > svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &:hover,\n  &:focus {\n    background: transparent;\n    outline: 0;\n\n    & > span.children {\n      background: ",
        ";\n      color: ",
        ";\n      outline: 0;\n    }\n\n    & > span.children > svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  & > .ant-badge {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: absolute;\n    top: -9px;\n    right: 0;\n    display: inline-block;\n    color: unset;\n    line-height: 1;\n\n    & > .ant-badge-status-dot {\n      position: relative;\n      display: inline-block;\n      width: 10px;\n      height: 10px;\n      vertical-align: middle;\n      border-radius: 50%;\n    }\n\n    & > .ant-badge-status-processing {\n      position: relative;\n      background-color: ",
        ";\n    }\n\n    & > .ant-badge-status-processing::after {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 1px solid ",
        ";\n      border-radius: 50%;\n      animation: antStatusProcessing 1.2s infinite ease-in-out;\n      content: '';\n    }\n  }\n\n  & > .ant-badge-status {\n    line-height: inherit;\n    vertical-align: baseline;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    btn_menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var btn_menu_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-1d972105-0"
})(btn_menu_templateObject(), function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,dist_index_esm/* themeGet */.R)("colors.primary_400") : (0,dist_index_esm/* themeGet */.R)("colors.primary_500");
}, index_esm/* color */.$_, index_esm/* typography */.cp, function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,dist_index_esm/* themeGet */.R)("colors.white") : (0,dist_index_esm/* themeGet */.R)("colors.primary_200");
}, function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,dist_index_esm/* themeGet */.R)("colors.white") : (0,dist_index_esm/* themeGet */.R)("colors.primary_200");
}, (0,dist_index_esm/* themeGet */.R)("colors.primary_400"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.primary_400"), (0,dist_index_esm/* themeGet */.R)("colors.primary_400"), index_esm/* layout */.bK, index_esm/* space */.Dh);
function BtnMenu(param) {
    var title = param.title, addBadge = param.addBadge, isFocused = param.isFocused, style = param.style, children = param.children, type = param.type, onClick = param.onClick, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(btn_menu_Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        title: title,
        type: type,
        disabled: disabled,
        onClick: onClick,
        isFocused: isFocused,
        children: [
            addBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                status: "processing"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "children",
                children: children
            })
        ]
    }));
}
/* harmony default export */ var buttons_btn_menu = (BtnMenu);

// EXTERNAL MODULE: ./src/theme/icons/logout.js
var logout = __webpack_require__(34438);
;// CONCATENATED MODULE: ./src/components/btn-logout/index.js








function BtnLogout() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var handleSignout = (0,react.useCallback)(function() {
        dispatch((0,auth/* signoutRequest */.yU)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(buttons_btn_menu, {
        title: translations/* default */.Z[languageCode].logout,
        type: "button",
        onClick: handleSignout,
        style: {
            width: [
                "76px",
                "76px",
                "76px",
                "100px"
            ],
            height: [
                "50px",
                "50px",
                "50px",
                "64px"
            ],
            mb: "m"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(logout/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                fontSize: [
                    "pSmall",
                    "pSmall",
                    "pSmall",
                    "pLarge"
                ],
                lineHeights: [
                    "pSmall",
                    "pSmall",
                    "pSmall",
                    "pLarge"
                ],
                fontWeight: "normal",
                color: "inherit",
                children: translations/* default */.Z[languageCode].logout
            })
        ]
    });
}
/* harmony default export */ var btn_logout = (BtnLogout);

;// CONCATENATED MODULE: ./src/theme/onboarding/index.js

function onboarding_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 72px;\n\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    onboarding_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function onboarding_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  position: relative;\n  height: 8px;\n  border-radius: 3px;\n\n  :after {\n    content: ' ';\n    position: absolute;\n    top: 0px;\n    background-color: ",
        ";\n    height: 8px;\n    width: ",
        "%;\n    border-radius: 3px;\n\n    ",
        "\n  }\n"
    ]);
    onboarding_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var onboarding_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7eb7e116-0"
})(onboarding_templateObject(), index_esm/* color */.$_, index_esm/* space */.Dh, index_esm/* border */.Cg);
var Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7eb7e116-1"
})(onboarding_templateObject1(), index_esm/* color */.$_, index_esm/* space */.Dh, index_esm/* layout */.bK, function(param) {
    var colorLine = param.colorLine;
    return (0,dist_index_esm/* themeGet */.R)("colors.".concat(colorLine));
}, function(param) {
    var percent = param.percent;
    return percent;
}, index_esm/* border */.Cg);
function Onboarding(param) {
    var label = param.label, percent = param.percent, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_Wrapper, {
        bg: disabled ? "primary_400" : "primary_600",
        m: [
            "0px",
            "0px",
            "0px",
            "xs"
        ],
        borderRadius: [
            "0px",
            "0px",
            "0px",
            "4px"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                !disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {
                    bg: "primary_500",
                    percent: percent,
                    colorLine: "warning",
                    width: [
                        "64px",
                        "64px",
                        "64px",
                        "84px"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    pt: disabled ? "0" : "xxs",
                    fontSize: "pSmall",
                    lineHeights: "pSmall",
                    fontWeight: "bold",
                    color: "white",
                    children: label
                })
            ]
        })
    });
}
/* harmony default export */ var onboarding = (Onboarding);

;// CONCATENATED MODULE: ./src/components/menu/index.js

function menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  display: flex;\n  justify-content: center;\n\n  z-index: 999;\n\n  /* On a phone the rail is a drawer: off screen until the burger opens it, so\n     the page keeps its whole width. From the first breakpoint up it is the\n     fixed rail it has always been, and the button below is not rendered. */\n  transform: translateX(",
        ");\n  transition: transform 0.2s ease-in-out;\n\n  @media (min-width: ",
        ") {\n    transform: none;\n  }\n"
    ]);
    menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 56px;\n  z-index: 1001;\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    menu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    menu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function menu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  background: transparent;\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    menu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 998;\n  background: rgba(0, 0, 0, 0.4);\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  overflow: auto;\n\n  background: ",
        ";\n\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  -ms-overflow-style: none; /* for Internet Explorer, Edge */\n  scrollbar-width: none; /* for Firefox */\n  &:-webkit-scrollbar {\n    display: none; /* for Chrome, Safari, and Opera */\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  cursor: pointer;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


























var menu_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-0"
})(menu_templateObject(), index_esm/* position */.FK, index_esm/* layout */.bK, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "0" : "-100%";
}, (0,dist_index_esm/* themeGet */.R)("breakpoints.0"));
/* Closed, the drawer takes the logo off screen with it, so the phone gets its
   own small mark beside the button — otherwise the top of the page says
   nothing about whose application this is. */ var MobileBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-1"
})(menu_templateObject1(), (0,dist_index_esm/* themeGet */.R)("breakpoints.0"));
var BurgerButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-785514be-2"
})(menu_templateObject2(), (0,dist_index_esm/* themeGet */.R)("colors.primary_500"), (0,dist_index_esm/* themeGet */.R)("colors.white"));
/* Inside the drawer and at its far corner: over the logo it read as a cross on
   the mark itself, which is where a person looks first. */ var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-785514be-3"
})(menu_templateObject3(), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("breakpoints.0"));
/* Tapping anything else closes the drawer, which is what a phone user expects
   and what stops the page underneath being operated blind. */ var Backdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-4"
})(_templateObject4(), (0,dist_index_esm/* themeGet */.R)("breakpoints.0"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-5"
})(_templateObject5(), index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("colors.primary_500"));
var menu_Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-6"
})(_templateObject6(), index_esm/* flexbox */.GQ, index_esm/* layout */.bK, index_esm/* space */.Dh);
var WrapHelp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-7"
})(_templateObject7(), index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("colors.white"));
var WrapUpgrade = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-785514be-8"
})(_templateObject8(), index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("colors.white"));
var WrapItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-785514be-9"
})(_templateObject9());
var StyledA = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-785514be-10"
})(_templateObject10());
function Menu() {
    var pathname = (0,next_router.useRouter)().pathname;
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref = (0,es/* useSelector */.v9)(profile/* default */.Z), completitionPerc = ref.completitionPerc, _payload = ref.payload, company = _payload.company, onboard = _payload.onboard, hasPROPlan = _payload.hasPROPlan;
    var ref1 = (0,es/* useSelector */.v9)(teams/* default */.ZP), canAccessAnalytics = ref1.canAccessAnalytics, canAccessBilling = ref1.canAccessBilling;
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    // A tap that leads somewhere has already done its job: the drawer closes with
    // the page change rather than staying over what the person went to read.
    (0,react.useEffect)(function() {
        setIsOpen(false);
    }, [
        pathname
    ]);
    var ref3 = onboard || {}, tmp = ref3.completition, current = (tmp === void 0 ? {
        current: 0
    } : tmp).current;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileBar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerButton, {
                        type: "button",
                        "aria-label": "Open menu",
                        "aria-expanded": false,
                        onClick: function() {
                            return setIsOpen(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(burger, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* SymbolLogo */.X$, {
                        style: {
                            color: (0,dist_index_esm/* themeGet */.R)("colors.primary_500")({
                                theme: theme
                            }),
                            display: "block",
                            height: [
                                "32px"
                            ]
                        }
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop, {
                onClick: function() {
                    return setIsOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_Wrapper, {
                width: [
                    "200px",
                    "96px",
                    "96px",
                    "165px"
                ],
                top: "0",
                bottom: "0",
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        type: "button",
                        "aria-label": "Close menu",
                        onClick: function() {
                            return setIsOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        pt: [
                            "s",
                            "s",
                            "s",
                            "l"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_Box, {
                                flexDirection: "column",
                                children: [
                                    (company === null || company === void 0 ? void 0 : company.code) === "SL_DE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/bookrix_logo.png",
                                        width: "60",
                                        height: "60",
                                        alt: "Logo BookRix"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* SymbolLogo */.X$, {
                                        style: {
                                            color: (0,dist_index_esm/* themeGet */.R)("colors.white")({
                                                theme: theme
                                            }),
                                            display: "block",
                                            height: [
                                                "48px",
                                                "42px",
                                                "42px",
                                                "64px"
                                            ],
                                            mb: [
                                                "m",
                                                "xs",
                                                "xs",
                                                "0"
                                            ]
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(btn_menu, {
                                        title: "dashboard",
                                        style: {
                                            mt: "l"
                                        },
                                        isFocused: true,
                                        route: [
                                            "/",
                                            "/dashboard",
                                            "/home"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(feed, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                lineHeights: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                fontWeight: "normal",
                                                color: "inherit",
                                                children: translations/* default */.Z[languageCode].dashboard
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(btn_menu, {
                                        title: "services",
                                        route: [
                                            "/services"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(list_ul, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                lineHeights: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                fontWeight: "normal",
                                                color: "inherit",
                                                children: translations/* default */.Z[languageCode].Services
                                            })
                                        ]
                                    }),
                                    canAccessAnalytics && /*#__PURE__*/ (0,jsx_runtime.jsxs)(btn_menu, {
                                        title: "analytics",
                                        route: [
                                            "/analytics"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(timelinechart, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                lineHeights: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                fontWeight: "normal",
                                                color: "inherit",
                                                children: translations/* default */.Z[languageCode].analytics
                                            })
                                        ]
                                    }),
                                    canAccessBilling && /*#__PURE__*/ (0,jsx_runtime.jsxs)(btn_menu, {
                                        title: "billing",
                                        route: [
                                            "/billing"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_card/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                lineHeights: [
                                                    "pSmall",
                                                    "pSmall",
                                                    "pSmall",
                                                    "pLarge"
                                                ],
                                                fontWeight: "normal",
                                                color: "inherit",
                                                children: translations/* default */.Z[languageCode].billing
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_Box, {
                                flexDirection: "column",
                                mt: "m",
                                children: [
                                    company && company.code === "SL_US" && !hasPROPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.streetlib.com/pricing/",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapUpgrade, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lightning, {
                                                    color: "#EF9800"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: [
                                                        "pSmall",
                                                        "pSmall",
                                                        "pSmall",
                                                        "pLarge"
                                                    ],
                                                    lineHeights: [
                                                        "pSmall",
                                                        "pSmall",
                                                        "pSmall",
                                                        "pLarge"
                                                    ],
                                                    fontWeight: "normal",
                                                    color: "inherit",
                                                    children: translations/* default */.Z[languageCode].upgrade
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                        placement: "topRight",
                                        options: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapItem, {
                                                title: translations/* default */.Z[languageCode].faq,
                                                href: "https://help.streetlib.com",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                                                    label: translations/* default */.Z[languageCode].faq
                                                })
                                            }, "help"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapItem, {
                                                title: translations/* default */.Z[languageCode].community,
                                                href: "https://community.streetlib.it/join?invitation_token=fb074f6465dee2de3ec0d2d29446de14ed7ccc87-e595924a-07b0-44bc-8601-c10dfd7e59dd",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                                                    label: translations/* default */.Z[languageCode].community
                                                })
                                            }, "community"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapItem, {
                                                title: translations/* default */.Z[languageCode]["privacy policy"],
                                                href: "https://www.streetlib.com/privacy",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                                                    label: translations/* default */.Z[languageCode]["privacy policy"]
                                                })
                                            }, "privacy"), 
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapHelp, {
                                            mb: "s",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(help, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: [
                                                        "pSmall",
                                                        "pSmall",
                                                        "pSmall",
                                                        "pLarge"
                                                    ],
                                                    lineHeights: [
                                                        "pSmall",
                                                        "pSmall",
                                                        "pSmall",
                                                        "pLarge"
                                                    ],
                                                    fontWeight: "normal",
                                                    color: "inherit",
                                                    children: translations/* default */.Z[languageCode].help
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_logout, {}),
                                    current !== 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/onboarding",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledA, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding, {
                                                disabled: pathname === "/onboarding",
                                                percent: completitionPerc,
                                                label: translations/* default */.Z[languageCode]["On Boarding"]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var menu = (Menu);

;// CONCATENATED MODULE: ./src/theme/layouts/page.js
/* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable no-nested-ternary */ 
function page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var page_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c61ef011-0"
})(page_templateObject(), index_esm/* space */.Dh);
var page = function(param) {
    var children = param.children;
    var paddingTop = (0,hooks/* useNativePadding */.RS)();
    var pathname = (0,next_router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_Wrapper, {
        ml: pathname !== "/profile" && pathname !== "/disabled" && pathname !== "/services" && pathname !== "/enable_service" ? [
            0,
            "96px",
            "96px",
            "165px"
        ] : 0,
        pt: paddingTop,
        children: [
            pathname !== "/profile" && pathname !== "/disabled" && pathname !== "/services" && pathname !== "/enable_service" && /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {}),
            children
        ]
    });
};
/* harmony default export */ var layouts_page = (page);

;// CONCATENATED MODULE: ./src/components/auth-switch/index.js
/* eslint-disable no-nested-ternary */ 















function AuthSwitch(param) {
    var children = param.children;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname, isReady = router.isReady, query = router.query;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.profile;
    }), isWaitingProfile = ref.isGetWaiting, guid = ref.payload.guid;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }), authState = ref1.authState, redirectPathname = ref1.redirectPathname, payload = ref1.payload;
    var ref2 = (0,es/* useSelector */.v9)(profile/* default */.Z), isEnabled = ref2.isEnabled, redirectPath = ref2.redirectPath, onboardComplete = ref2.onboardComplete, isAdmin = ref2.isAdmin, isAdminDe = ref2.isAdminDe, needsPayment = ref2.needsPayment;
    var canAccessSection = (0,es/* useSelector */.v9)(teams/* default */.ZP).canAccessSection;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    (0,react.useEffect)(function() {
        // Don't redirect to onboarding if there's an OAuth redirect pending
        if (redirectPath && !redirectPathname) {
            try {
                var currentPath = router.pathname;
                var redirectBasePath = new URL(redirectPath, window.location.origin).pathname;
                if (currentPath !== redirectBasePath) {
                    router.push(redirectPath);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Invalid redirectPath:", redirectPath, error);
            }
        }
    }, [
        redirectPath,
        redirectPathname,
        router,
        onboardComplete,
        isAdmin,
        isAdminDe,
        authState
    ]);
    // Handle redirect after successful OAuth signin
    (0,react.useEffect)(function() {
        if (authState === "SIGNEDIN" && redirectPathname && redirectPathname !== "/") {
            var currentPath = router.pathname;
            // Only redirect if we're not already on the target path
            if (currentPath !== redirectPathname) {
                // eslint-disable-next-line no-console
                console.log("\uD83C\uDFAF Auth-switch redirecting after signin:", redirectPathname);
                router.push(redirectPathname);
            }
            // Clear the redirect pathname after redirect to prevent loops
            dispatch((0,auth/* clearRedirectPathname */.Hn)());
        }
    }, [
        authState,
        redirectPathname,
        router,
        dispatch
    ]);
    // Check if user needs payment and redirect to onboarding
    (0,react.useEffect)(function() {
        if (authState === "SIGNEDIN" && !isWaitingProfile && guid && needsPayment) {
            var allowedPages = [
                "/profile",
                "/services",
                "/enable-service",
                "/billing/profile",
                "/billing/payment-account",
                "/billing/summary-billing-profile",
                "/billing/summary-payment-account",
                "/billing/profiles",
                "/onboarding", 
            ];
            var isOnAllowedPage = allowedPages.includes(pathname);
            if (!isOnAllowedPage) {
                router.push("/onboarding");
            }
        }
    }, [
        authState,
        pathname,
        needsPayment,
        isWaitingProfile,
        guid,
        router
    ]);
    // Check onboarding status on navigation
    (0,react.useEffect)(function() {
        if (authState === "SIGNEDIN" && !isWaitingProfile && guid) {
            // Check if user needs onboarding and is not on an allowed page
            var allowedPages = [
                "/profile",
                "/services",
                "/enable-service",
                "/billing/profile",
                "/billing/payment-account",
                "/billing/summary-billing-profile",
                "/billing/summary-payment-account",
                "/billing/profiles",
                "/onboarding", 
            ];
            var needsOnboarding = !isAdmin && !isAdminDe && !onboardComplete;
            var isOnAllowedPage = allowedPages.includes(pathname);
            if (needsOnboarding && !isOnAllowedPage) {
                router.push("/onboarding");
            }
        }
    }, [
        authState,
        pathname,
        onboardComplete,
        isAdmin,
        isAdminDe,
        isWaitingProfile,
        guid,
        router
    ]);
    var locale = (0,react.useMemo)(function() {
        return [
            "de",
            "it",
            "pt"
        ].includes(languageCode) ? languageCode : "en";
    }, [
        languageCode
    ]);
    var content = (0,react.useMemo)(function() {
        // Show loader while checking authentication or loading profile
        if (authState === "LOADING" || isWaitingProfile && !guid) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                authState: authState
            });
        }
        // If not signed in, redirect to login
        if (authState === "SIGNEDOUT") {
            router.push("/login");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                authState: "LOADING"
            });
        }
        // If signed in but not enabled, show disabled page
        if (!isEnabled) return /*#__PURE__*/ (0,jsx_runtime.jsx)(disabled, {});
        // Block sections the team member has no scope for (direct URL access)
        var requiredSection = (0,teams/* getRequiredSection */.WG)(pathname);
        if (requiredSection && !canAccessSection(requiredSection)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_page, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(not_allowed, {})
            });
        }
        // User is signed in and enabled, show the page
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_page, {
            children: children
        });
    }, [
        isWaitingProfile,
        isEnabled,
        authState,
        children,
        router,
        guid,
        pathname,
        canAccessSection
    ]);
    (0,react.useEffect)(function() {
        if (!isReady) return;
        var accessToken = query.accessToken, idToken = query.idToken, refreshToken = query.refreshToken, timestamp = query.timestamp, restQuery = (0,_object_without_properties/* default */.Z)(query, [
            "accessToken",
            "idToken",
            "refreshToken",
            "timestamp"
        ]);
        // Check if this is OAuth callback
        var isOAuthCallback = pathname === "/auth/oauth/streetlib/callback";
        if (isOAuthCallback) {
            // OAuth callback will be handled by the callback page component
            // No need to dispatch signin here
            return;
        }
        // Check if we have tokens in query string (legacy customer care scenario)
        // This check should happen BEFORE checking if user is already signed in
        var hasAllTokens = accessToken && idToken && refreshToken;
        if (hasAllTokens) {
            // Legacy token-based authentication (customer care impersonation)
            // eslint-disable-next-line no-console
            console.log("\uD83D\uDD11 Found all 3 tokens in URL, using legacy authentication", {
                hasAccessToken: !!accessToken,
                hasIdToken: !!idToken,
                hasRefreshToken: !!refreshToken,
                pathname: pathname
            });
            dispatch((0,auth/* signinRequest */.Lz)({
                pathname: pathname,
                query: restQuery,
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken
            }));
            return;
        }
        // Don't verify tokens if user is already signed in (but only if no URL tokens)
        if (authState === "SIGNEDIN") {
            // eslint-disable-next-line no-console
            console.log("✅ User already signed in, skipping token verification", {
                authState: authState,
                pathname: pathname
            });
            return;
        }
        // If loading and we have persisted tokens, verify them immediately
        if (authState === "LOADING") {
            var persistedTokens = payload === null || payload === void 0 ? void 0 : payload.signInUserSession;
            if (persistedTokens === null || persistedTokens === void 0 ? void 0 : persistedTokens.accessToken) {
                // eslint-disable-next-line no-console
                console.log("\uD83D\uDD04 Found persisted tokens while loading, verifying immediately", {
                    hasAccessToken: !!persistedTokens.accessToken,
                    hasOAuthMetadata: !!persistedTokens.oauthMetadata,
                    pathname: pathname
                });
                dispatch((0,auth/* signinRequest */.Lz)((0,_object_spread/* default */.Z)({
                    pathname: pathname,
                    query: {}
                }, persistedTokens)));
                return;
            }
            // If loading but no persisted tokens and not on OAuth callback, check storage
            if (!isOAuthCallback) {
                // Check if there are any tokens in localStorage/sessionStorage
                var hasTokensInStorage = function() {
                    try {
                        // Check localStorage for persisted tokens
                        var persistedAuth = localStorage.getItem("persist:root");
                        if (persistedAuth) {
                            var ref;
                            var parsed = JSON.parse(persistedAuth);
                            var authData = JSON.parse(parsed.auth || "{}");
                            var tokens = (ref = authData.payload) === null || ref === void 0 ? void 0 : ref.signInUserSession;
                            return !!((tokens === null || tokens === void 0 ? void 0 : tokens.accessToken) || (tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken));
                        }
                        return false;
                    } catch (error) {
                        return false;
                    }
                };
                var hasTokens = hasTokensInStorage();
                if (!hasTokens) {
                    // No tokens in storage, redirect to login
                    // eslint-disable-next-line no-console
                    console.log("\uD83D\uDEAB No tokens in storage, redirecting to login", {
                        authState: authState,
                        pathname: pathname,
                        isOAuthCallback: isOAuthCallback
                    });
                    router.push("/login");
                    return;
                }
                // eslint-disable-next-line no-console
                console.log("⏳ Loading but no persisted tokens, waiting for auth state update", {
                    authState: authState,
                    pathname: pathname,
                    isOAuthCallback: isOAuthCallback,
                    hasTokensInStorage: hasTokens
                });
                // Don't redirect immediately, let the auth state settle
                return;
            }
            return;
        }
        // Check if we have only accessToken (shouldn't happen in normal flow)
        if (accessToken) {
            // Only accessToken without other tokens - this shouldn't happen in normal flow
            // Redirect to OAuth login
            router.push("/login");
        } else {
            // No tokens in query string - check if we have persisted tokens
            var persistedTokens1 = payload === null || payload === void 0 ? void 0 : payload.signInUserSession;
            if (persistedTokens1 === null || persistedTokens1 === void 0 ? void 0 : persistedTokens1.accessToken) {
                // We have persisted tokens, verify them
                // eslint-disable-next-line no-console
                console.log("\uD83D\uDD04 Found persisted tokens, verifying...", {
                    hasAccessToken: !!persistedTokens1.accessToken,
                    hasOAuthMetadata: !!persistedTokens1.oauthMetadata,
                    pathname: pathname,
                    currentAuthState: authState
                });
                dispatch((0,auth/* signinRequest */.Lz)((0,_object_spread/* default */.Z)({
                    pathname: pathname,
                    query: restQuery
                }, persistedTokens1)));
            } else if (authState !== "LOADING") {
                // No tokens at all - redirect to OAuth login only if not already loading
                // eslint-disable-next-line no-console
                console.log("\uD83D\uDEAB No tokens found, redirecting to login");
                router.push("/login");
            } else {
                // No tokens in payload but loading - check storage to be sure
                var hasTokensInStorage1 = function() {
                    try {
                        var persistedAuth = localStorage.getItem("persist:root");
                        if (persistedAuth) {
                            var ref;
                            var parsed = JSON.parse(persistedAuth);
                            var authData = JSON.parse(parsed.auth || "{}");
                            var tokens = (ref = authData.payload) === null || ref === void 0 ? void 0 : ref.signInUserSession;
                            return !!((tokens === null || tokens === void 0 ? void 0 : tokens.accessToken) || (tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken));
                        }
                        return false;
                    } catch (error) {
                        return false;
                    }
                };
                var hasTokens1 = hasTokensInStorage1();
                if (!hasTokens1) {
                    // eslint-disable-next-line no-console
                    console.log("\uD83D\uDEAB No tokens in storage either, redirecting to login", {
                        authState: authState,
                        pathname: pathname
                    });
                    router.push("/login");
                } else {
                    // eslint-disable-next-line no-console
                    console.log("⏳ No tokens in payload but found in storage, waiting for auth state update", {
                        authState: authState,
                        pathname: pathname,
                        hasTokensInStorage: hasTokens1
                    });
                }
            }
        }
    }, [
        dispatch,
        isReady,
        pathname,
        query,
        router,
        payload,
        authState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(provider/* default */.Z, {
        messages: translations/* default */.Z[locale],
        locale: locale,
        defaultLocale: "en",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, {
                    htmlAttributes: {
                        lang: locale
                    }
                }),
                content
            ]
        })
    });
}
/* harmony default export */ var auth_switch = (AuthSwitch);


/***/ }),

/***/ 85480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bs": function() { return /* binding */ useDimensions; },
/* harmony export */   "O3": function() { return /* binding */ useOutsideClick; },
/* harmony export */   "RS": function() { return /* binding */ useNativePadding; },
/* harmony export */   "ht": function() { return /* binding */ useBornOnMaxDate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);


// RETURN callback if is clicked outside
// eslint-disable-next-line import/prefer-default-export
var useOutsideClick = function(ref, callback, extraClass) {
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.key === "Escape") {
            callback();
        }
        var elements = document.getElementsByClassName(extraClass);
        for(var i = 0; i < elements.length; i += 1){
            if (elements[i] && elements[i].contains(e.target)) {
                return;
            }
        }
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    }, [
        callback,
        ref,
        extraClass
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("click", handleClick, true);
        return function() {
            document.removeEventListener("click", handleClick, true);
        };
    });
};
var useDimensions = function() {
    var intervalId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var getSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var isClient = "object" === "object";
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        };
    }, []);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize()), windowSize = ref[0], setWindowSize = ref[1];
    var handleResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var delay = 250;
        clearTimeout(intervalId.current);
        intervalId.current = setTimeout(function() {
            var size = getSize();
            if (size) {
                setWindowSize(size);
            }
        }, delay);
    }, [
        intervalId,
        getSize
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
var useNativePadding = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("0px"), nativePadding = ref[0], setNativePadding = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isServer = "object" === "undefined";
        if (!isServer && window.ReactNativeWebView) {
            setNativePadding("36px");
        }
    }, []);
    return nativePadding;
};
var useBornOnMaxDate = function() {
    var date = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var today = moment__WEBPACK_IMPORTED_MODULE_1___default()();
        return today.subtract(18, "year");
    }, []);
    return date;
};


/***/ }),

/***/ 93478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ setLanguage; }
/* harmony export */ });
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73714);
/* eslint-disable import/prefer-default-export */ 
function setLanguage(payload) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SET_LANGUAGE */ .AFF,
        payload: payload
    };
}


/***/ }),

/***/ 81061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WG": function() { return /* binding */ getRequiredSection; }
/* harmony export */ });
/* unused harmony export SECTION_SCOPES */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);
/* eslint-disable camelcase */ 
// Maps a route section to the team scope required to access it.
// Catalog is intentionally not handled here: that section does not exist in this app.
var SECTION_SCOPES = {
    analytics: "analytics:read",
    billing: "bill:read",
    catalog: "catalog:read"
};
// Returns the gated section for a given pathname, or null if the route is not gated.
function getRequiredSection() {
    var pathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (pathname.startsWith("/analytics")) return "analytics";
    if (pathname.startsWith("/billing")) return "billing";
    return null;
}
var selectTeams = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.teams;
}, function(teams) {
    var ref = teams || {}, payload = ref.payload, loaded = ref.loaded, error = ref.error;
    var ref1 = payload || {}, userRole = ref1.user_role, userScopes = ref1.user_scopes;
    var scopes = Array.isArray(userScopes) ? userScopes : [];
    var isOwner = userRole === "owner";
    // Fail-open: while loading, on error, or for owners, grant access to everything.
    var allowAll = !loaded || !!error || isOwner;
    var hasScope = function(scope) {
        return allowAll || scopes.includes(scope);
    };
    var canAccessSection = function(section) {
        var required = SECTION_SCOPES[section];
        if (!required) return true;
        return hasScope(required);
    };
    return {
        userRole: userRole,
        userScopes: scopes,
        isOwner: isOwner,
        loaded: !!loaded,
        hasScope: hasScope,
        canAccessSection: canAccessSection,
        canAccessAnalytics: canAccessSection("analytics"),
        canAccessBilling: canAccessSection("billing")
    };
});
/* harmony default export */ __webpack_exports__["ZP"] = (selectTeams);


/***/ }),

/***/ 97998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68697);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57708);
/* eslint-disable camelcase */ 

/* harmony default export */ __webpack_exports__["Z"] = ((0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)(function(state) {
    return state.warning.payload;
}, _config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, function(payload, param) {
    var languageCode = param.languageCode;
    return payload.map(function(warning) {
        return {
            key: warning.id,
            message: warning.data.msg[languageCode],
            level: warning.data.level,
            panel_class: warning.data.panel_class
        };
    });
}));


/***/ }),

/***/ 44051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var theme_content_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52005);
/* eslint-disable no-nested-ternary */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  background-image: url(",
        ");\n  background-position: 0% 0%;\n  background-size: cover;\n  background-repeat: no-repeat;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fabfe42d-0"
})(_templateObject());
var WrapAvatar = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fabfe42d-1"
})(_templateObject1());
var AvatarPicture = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fabfe42d-2"
})(_templateObject2(), function(param) {
    var picture = param.picture;
    return picture;
});
function CustomAvatar(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapAvatar, {
            children: data.avatar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AvatarPicture, {
                picture: data.avatar
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_content_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                width: 48,
                height: 48,
                lines: [
                    {
                        x: 0,
                        y: 0,
                        width: 48,
                        height: 48
                    }, 
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomAvatar);


/***/ }),

/***/ 9246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14141);
/* harmony import */ var theme_icons_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39024);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 56px;\n  min-width: 140px;\n  background: transparent;\n  padding: 0;\n  outline: 0;\n\n  & > span {\n    background: ",
        ";\n\n    padding: 0 ",
        "px;\n\n    ",
        "\n    ",
        "\n\n    border: ",
        ";\n\n    border-radius: 12px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    border-color: ",
        ";\n    background: transparent;\n    outline: 0;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        "px;\n  width: 18px;\n  height: 18px;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(_templateObject());
var Button = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9366ad3e-0"
})(_templateObject1(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.white"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, function(props) {
    return !props.active ? "2px solid" : "none";
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_300"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .border */ .Cg);
var WrapLoader = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9366ad3e-1"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.xs"), rotate);
function Btn(_param) {
    var isWaiting = _param.isWaiting, style = _param.style, title = _param.title, label = _param.label, type = _param.type, onClick = _param.onClick, disabled = _param.disabled, active = _param.active, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "isWaiting",
        "style",
        "title",
        "label",
        "type",
        "onClick",
        "disabled",
        "active"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        title: title || label,
        "aria-label": title || label,
        fontSize: "h4",
        lineHeight: "h4",
        fontWeight: "bold",
        color: "grey_400",
        px: "l"
    }, style), {
        type: type,
        disabled: disabled || isWaiting,
        onClick: onClick,
        active: active
    }), rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
            children: [
                label,
                isWaiting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapLoader, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        width: 18
                    })
                })
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Btn);


/***/ }),

/***/ 73909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63922);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding: 0;\n  background: transparent;\n  outline: 0;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  & > span.children {\n    overflow: hidden;\n    background: ",
        ";\n    border-radius: 12px;\n\n    ",
        "\n    ",
        "\n\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    & > svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &:hover {\n    background: transparent;\n    outline: 0;\n\n    & > span.children {\n      background: ",
        ";\n    }\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  & > .ant-badge {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: absolute;\n    top: -9px;\n    right: 0;\n    display: inline-block;\n    color: unset;\n    line-height: 1;\n\n    & > .ant-badge-status-dot {\n      position: relative;\n      display: inline-block;\n      width: 10px;\n      height: 10px;\n      vertical-align: middle;\n      border-radius: 50%;\n    }\n\n    & > .ant-badge-status-processing {\n      position: relative;\n      background-color: ",
        ";\n    }\n\n    & > .ant-badge-status-processing::after {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 1px solid ",
        ";\n      border-radius: 50%;\n      animation: antStatusProcessing 1.2s infinite ease-in-out;\n      content: '';\n    }\n  }\n\n  & > .ant-badge-status {\n    line-height: inherit;\n    vertical-align: baseline;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-e540dd3d-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_50"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, function(param) {
    var iconColor = param.iconColor;
    return iconColor || (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_300");
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_100"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function BtnMenu(param) {
    var title = param.title, iconColor = param.iconColor, addBadge = param.addBadge, style = param.style, children = param.children, type = param.type, onClick = param.onClick, disabled = param.disabled;
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_5__/* .ThemeContext */ .Ni);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        iconColor: (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.".concat(iconColor))({
            theme: theme
        })
    }, style), {
        type: type,
        disabled: disabled,
        onClick: onClick,
        title: title,
        "aria-label": title,
        children: [
            addBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                status: "processing"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "children",
                children: children
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (BtnMenu);


/***/ }),

/***/ 52005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14141);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50056);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24561);





function CustomContentLoader(param) {
    var width = param.width, height = param.height, speed = param.speed, backgroundColor = param.backgroundColor, foregroundColor = param.foregroundColor, lines = param.lines;
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__/* .ThemeContext */ .Ni);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        speed: speed || 2,
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        backgroundColor: backgroundColor || (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__/* .themeGet */ .R)("colors.primary_100")({
            theme: theme
        }),
        foregroundColor: foregroundColor || (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__/* .themeGet */ .R)("colors.primary_50")({
            theme: theme
        }),
        children: lines.map(function(line) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: line.x,
                y: line.y,
                rx: line.rx,
                ry: line.ry,
                width: line.width,
                height: line.height
            }, "".concat(line.x, "-").concat(line.y));
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomContentLoader);


/***/ }),

/***/ 16768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dropdown; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
;// CONCATENATED MODULE: ./src/theme/dropdown/list-menu/index.js


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: ",
        ";\n  position: absolute;\n  right: 0;\n  padding-top: ",
        "px;\n  z-index: 999;\n\n  ",
        "\n\n  & > ul {\n    width: fit-content;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04),\n      0px 10px 20px rgba(0, 0, 0, 0.04);\n\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 ",
        "px;\n  min-width: 130px;\n  height: 48px;\n  border-bottom: 1px solid ",
        ";\n  background: ",
        ";\n\n  :last-child {\n    border-bottom: none;\n  }\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7e761299-0"
})(_templateObject(), index_esm/* space */.Dh, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, (0,dist_index_esm/* themeGet */.R)("space.xs"), function(param) {
    var position = param.position;
    return (0,_object_spread/* default */.Z)({}, position);
}, (0,dist_index_esm/* themeGet */.R)("colors.primary_100"));
var Li = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7e761299-1"
})(_templateObject1(), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("colors.primary_100"), function(param) {
    var isActive = param.isActive;
    return isActive ? (0,dist_index_esm/* themeGet */.R)("colors.primary_100") : (0,dist_index_esm/* themeGet */.R)("colors.white");
}, (0,dist_index_esm/* themeGet */.R)("colors.primary_100"));
function ListMenu(param) {
    var options = param.options, isOpen = param.isOpen, parentHeight = param.parentHeight, _placement = param.placement, placement = _placement === void 0 ? "bottomLeft" : _placement;
    var position = (0,react.useMemo)(function() {
        var result = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        switch(placement){
            case "bottomLeft":
                return {
                    top: parentHeight,
                    right: 0
                };
            case "topRight":
                return {
                    bottom: parentHeight,
                    left: 0
                };
            default:
                return result;
        }
    }, [
        placement,
        parentHeight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        isOpen: isOpen,
        position: position,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Li, {
                    isActive: option.props.isActive,
                    children: option
                }, option.key);
            })
        })
    });
}
/* harmony default export */ var list_menu = (ListMenu);

;// CONCATENATED MODULE: ./src/theme/dropdown/index.js



function dropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    dropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    dropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var dropdown_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5463da8c-0"
})(dropdown_templateObject(), index_esm/* position */.FK);
var WrapButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5463da8c-1"
})(dropdown_templateObject1());
function CustomDropdown(param) {
    var options = param.options, children = param.children, style = param.style, placement = param.placement;
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useRef)(null);
    var handleClick = (0,react.useCallback)(function() {
        setOpen(!isOpen);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        onMouseEnter: function() {
            return setOpen(true);
        },
        onMouseLeave: function() {
            return setOpen(false);
        },
        onClick: handleClick
    }, style), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapButton, {
                ref: ref1,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list_menu, {
                placement: placement,
                options: options,
                isOpen: isOpen,
                parentHeight: ref1.current ? ref1.current.offsetHeight : 0
            })
        ]
    }));
}
/* harmony default export */ var dropdown = (CustomDropdown);


/***/ }),

/***/ 63546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: ",
        ";\n\n  & > span {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-right: ",
        "px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ea80ceae-0"
})(_templateObject(), function(param) {
    var isTitle = param.isTitle;
    return isTitle ? "none" : "pointer";
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_3__/* .themeGet */ .R)("space.xs"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_3__/* .themeGet */ .R)("colors.primary_300"));
function Item(param) {
    var onClick = param.onClick, icon = param.icon, label = param.label, isTitle = param.isTitle;
    if (isTitle) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
            isTitle: isTitle,
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                fontSize: "h4",
                lineHeight: "h4",
                fontWeight: "medium",
                color: "grey_600",
                children: label
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        onClick: onClick,
        children: [
            !!icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                fontSize: "display",
                lineHeight: "display",
                fontWeight: "medium",
                color: "grey_400",
                children: label
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Item);


/***/ }),

/***/ 28116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./src/theme/layouts/body.js
var body = __webpack_require__(89129);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/redux/action/warning.js
var warning = __webpack_require__(6482);
// EXTERNAL MODULE: ./src/redux/action/lang.js
var action_lang = __webpack_require__(93478);
// EXTERNAL MODULE: ./src/redux/action/auth.js
var auth = __webpack_require__(38006);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/warning.js
var reselect_warning = __webpack_require__(97998);
// EXTERNAL MODULE: ./src/theme/dropdown/index.js + 1 modules
var dropdown = __webpack_require__(16768);
// EXTERNAL MODULE: ./src/theme/dropdown/item/index.js
var item = __webpack_require__(63546);
// EXTERNAL MODULE: ./src/theme/buttons/btn-user-menu.js
var btn_user_menu = __webpack_require__(73909);
// EXTERNAL MODULE: ./src/theme/icons/web.js
var web = __webpack_require__(51024);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
// EXTERNAL MODULE: ./src/theme/icons/logout.js
var logout = __webpack_require__(34438);
// EXTERNAL MODULE: ./src/theme/icons/user.js
var user = __webpack_require__(64740);
// EXTERNAL MODULE: ./src/theme/buttons/btn-border.js
var btn_border = __webpack_require__(9246);
// EXTERNAL MODULE: ./src/theme/input/index.js
var input = __webpack_require__(18744);
// EXTERNAL MODULE: ./src/theme/modal/index.js
var modal = __webpack_require__(75436);
// EXTERNAL MODULE: ./src/theme/avatar/index.js
var avatar = __webpack_require__(44051);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/components/user-menu/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  & > div {\n    width: 100%;\n    max-width: 450px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  font-weight: normal;\n  color: ",
        ";\n\n  & > svg {\n    flex-shrink: 0;\n    margin-left: ",
        "px;\n    font-weight: normal;\n  }\n\n  & > span {\n    margin-right: ",
        "px;\n    font-size: 18px;\n    font-weight: normal;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















// import Notification from 'theme/icons/notification';








// Lingue: codice a 2 lettere nel trigger, nome esteso nel dropdown (senza bandiere)
var LANGUAGES = [
    {
        code: "en",
        label: "World (English)"
    },
    {
        code: "it",
        label: "Italiano"
    },
    {
        code: "de",
        label: "Deutsch"
    },
    {
        code: "pt",
        label: "Portugu\xeas"
    }
];
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eed32bf-0"
})(_templateObject(), index_esm/* space */.Dh);
var WrapBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eed32bf-1"
})(_templateObject1());
var WrapItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-6eed32bf-2"
})(_templateObject2());
var ModalBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eed32bf-3"
})(_templateObject3());
var LangTriggerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6eed32bf-4"
})(_templateObject4(), (0,dist_index_esm/* themeGet */.R)("colors.primary_300"), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("colors.grey_600"));
function UserMenu() {
    var adminRequestedStreetlibInternalId = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }).adminRequestedStreetlibInternalId;
    var ref = (0,react.useState)(false), impersonationModal = ref[0], setImpersonationModal = ref[1];
    var ref1 = (0,react.useState)(adminRequestedStreetlibInternalId), userImpersonationState = ref1[0], setUserImpersonationState = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var isVisible = (0,es/* useSelector */.v9)(function(state) {
        return state.warning;
    }).isVisible;
    var warnings = (0,es/* useSelector */.v9)(reselect_warning/* default */.Z);
    var ref2 = (0,es/* useSelector */.v9)(profile/* default */.Z), payload = ref2.payload, isAdmin = ref2.isAdmin, isEnabled = ref2.isEnabled;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var handleSendUserImpersonation = (0,react.useCallback)(function() {
        dispatch((0,auth/* setUserImpersonation */.m2)(userImpersonationState));
        setImpersonationModal(false);
    }, [
        dispatch,
        userImpersonationState
    ]);
    var handleWarning = (0,react.useCallback)(function() {
        dispatch((0,warning/* setWarningVisible */.Ic)(true));
    }, [
        dispatch
    ]);
    var handleSignout = (0,react.useCallback)(function() {
        dispatch((0,auth/* signoutRequest */.yU)());
    }, [
        dispatch
    ]);
    var handleImpersonation = (0,react.useCallback)(function() {
        setImpersonationModal(true);
    }, []);
    var handleCloseModal = (0,react.useCallback)(function() {
        setImpersonationModal(false);
    }, []);
    var userDropdownOptions = (0,react.useMemo)(function() {
        if (!isEnabled) {
            return [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(logout/* default */.Z, {}),
                    label: translations/* default */.Z[languageCode].logout,
                    onClick: handleSignout
                }, "logout"), 
            ];
        }
        var options = [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/profile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapItem, {
                    title: translations/* default */.Z[languageCode].profile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {}),
                        label: translations/* default */.Z[languageCode].profile
                    })
                }, "profile")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(logout/* default */.Z, {}),
                label: translations/* default */.Z[languageCode].logout,
                onClick: handleSignout
            }, "logout"), 
        ];
        if (isAdmin) {
            options.unshift(/*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {}),
                label: "Impersonation",
                onClick: handleImpersonation
            }, "user-impersonation"));
        }
        return options;
    }, [
        handleSignout,
        handleImpersonation,
        isAdmin,
        isEnabled,
        languageCode
    ]);
    var displayCode = (0,react.useMemo)(function() {
        var lang = LANGUAGES.find(function(l) {
            return l.code === languageCode;
        });
        return lang ? lang.code.toUpperCase() : "EN";
    }, [
        languageCode
    ]);
    var langOptions = (0,react.useCallback)(function() {
        return LANGUAGES.map(function(lang) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(item/* default */.Z, {
                label: lang.label,
                isActive: languageCode === lang.code,
                onClick: function() {
                    return dispatch((0,action_lang/* setLanguage */.m)({
                        language: lang.code
                    }));
                }
            }, lang.code);
        });
    }, [
        languageCode,
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                pr: "m",
                pb: "s",
                pt: "s",
                children: [
                    !isVisible && warnings.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_user_menu/* default */.Z, {
                        title: "warning",
                        type: "button",
                        style: {
                            width: [
                                "38px",
                                "38px",
                                "38px",
                                "56px"
                            ],
                            height: [
                                "38px",
                                "38px",
                                "38px",
                                "56px"
                            ],
                            mr: [
                                "xs",
                                "xs",
                                "xs",
                                "s"
                            ]
                        },
                        iconColor: "warning",
                        onClick: handleWarning,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {
                            style: {
                                width: [
                                    "18px",
                                    "18px",
                                    "18px",
                                    "26px"
                                ]
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                        style: {
                            position: "relative"
                        },
                        options: langOptions(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_user_menu/* default */.Z, {
                            type: "button",
                            style: {
                                width: [
                                    "56px",
                                    "56px",
                                    "56px",
                                    "80px"
                                ],
                                height: [
                                    "38px",
                                    "38px",
                                    "38px",
                                    "56px"
                                ],
                                ml: [
                                    "s",
                                    "s",
                                    "s",
                                    "m"
                                ],
                                mr: [
                                    "s",
                                    "s",
                                    "s",
                                    "m"
                                ]
                            },
                            title: "change language",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LangTriggerContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(web/* default */.Z, {
                                        style: {
                                            width: [
                                                "18px",
                                                "18px",
                                                "18px",
                                                "26px"
                                            ]
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: displayCode
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                        style: {
                            position: "relative"
                        },
                        options: userDropdownOptions,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_user_menu/* default */.Z, {
                            type: "button",
                            style: {
                                width: [
                                    "38px",
                                    "38px",
                                    "38px",
                                    "56px"
                                ],
                                height: [
                                    "38px",
                                    "38px",
                                    "38px",
                                    "56px"
                                ]
                            },
                            title: "user options",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                                data: payload
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                isVisible: impersonationModal,
                onClose: handleCloseModal,
                title: "User Impersonation",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                meta: {},
                                input: {
                                    onChange: function(e) {
                                        return setUserImpersonationState(e.target.value);
                                    },
                                    value: userImpersonationState
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapBtn, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                                    onClick: handleSendUserImpersonation,
                                    style: {
                                        width: "100%",
                                        maxWidth: "140px",
                                        px: 0,
                                        mb: "l"
                                    },
                                    type: "button",
                                    label: translations/* default */.Z[languageCode].send
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var user_menu = (UserMenu);

;// CONCATENATED MODULE: ./src/theme/header/index.js



function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n\n  /* On a phone this strip stays at the top of the screen and paints its own\n     white: scrolled under, the language, the account and the burger used to mix\n     with whatever passed beneath them. The left padding is the room the burger\n     and the mark occupy, which are fixed at the same height. */\n  @media (max-width: calc(",
        " - 1px)) {\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n    background: ",
        ";\n    padding-left: 104px;\n    min-height: 56px;\n    align-items: center;\n    box-shadow: 0 1px 0 ",
        ";\n  }\n\n  & > .left {\n    display: flex;\n    align-items: center;\n  }\n\n  & > .centered {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: ",
        "px 0;\n  }\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  width: 100%;\n"
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var header_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b3204ed-0"
})(header_templateObject(), index_esm/* space */.Dh, index_esm/* color */.$_, index_esm/* border */.Cg, (0,dist_index_esm/* themeGet */.R)("breakpoints.0"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.grey_200"), (0,dist_index_esm/* themeGet */.R)("space.s"));
var UserBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b3204ed-1"
})(header_templateObject1(), index_esm/* layout */.bK);
function Header(param) {
    var style = param.style, title = param.title, bodyColor = param.bodyColor, componentLeft = param.componentLeft, component = param.component, noWarning = param.noWarning;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                bg: bodyColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left",
                children: componentLeft
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "centered",
                children: component
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBar, {
                maxWidth: [
                    "236px",
                    "236px",
                    "236px",
                    "320px"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_menu, {
                    noWarning: noWarning
                })
            })
        ]
    }));
}
/* harmony default export */ var header = (Header);


/***/ }),

/***/ 56704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 18px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("svg").withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "width"
        ].includes(prop);
    }
}).withConfig({
    componentId: "sc-1e2f4bae-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function Card(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style), {
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M16.2 6.50918H1.8V4.70918H16.2V6.50918ZM16.2 15.5092H1.8V10.1092H16.2V15.5092ZM16.2 2.90918H1.8C0.801 2.90918 0 3.71018 0 4.70918V15.5092C0 16.5033 0.805887 17.3092 1.8 17.3092H16.2C17.1941 17.3092 18 16.5033 18 15.5092V4.70918C18 3.71018 17.19 2.90918 16.2 2.90918Z",
            fill: "currentColor"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 53107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CheckCircle() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9 0.227051C4.05 0.227051 0 4.27705 0 9.22705C0 14.1771 4.05 18.2271 9 18.2271C13.95 18.2271 18 14.1771 18 9.22705C18 4.27705 13.95 0.227051 9 0.227051ZM9 16.4271C5.031 16.4271 1.8 13.1961 1.8 9.22705C1.8 5.25805 5.031 2.02705 9 2.02705C12.969 2.02705 16.2 5.25805 16.2 9.22705C16.2 13.1961 12.969 16.4271 9 16.4271ZM13.131 5.24905L7.2 11.1801L4.869 8.85805L3.6 10.1271L7.2 13.7271L14.4 6.52705L13.131 5.24905Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 0.227051H18V18.2271H0V0.227051Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CheckCircle);


/***/ }),

/***/ 34438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Logout() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11.08 12.8171L13.67 10.2271H4V8.22705H13.67L11.08 5.63705L12.5 4.22705L17.5 9.22705L12.5 14.2271L11.08 12.8171ZM16 0.227051C17.1046 0.227051 18 1.12248 18 2.22705V6.89705L16 4.89705V2.22705H2V16.2271H16V13.5571L18 11.5571V16.2271C18 17.3316 17.1046 18.2271 16 18.2271H2C0.89 18.2271 0 17.3271 0 16.2271V2.22705C0 1.11705 0.89 0.227051 2 0.227051H16Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 0.227051H18V18.2271H0V0.227051Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Logout);


/***/ }),

/***/ 64740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function User(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width || "18",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9 1.40918C11.2091 1.40918 13 3.20004 13 5.40918C13 7.61832 11.2091 9.40918 9 9.40918C6.79086 9.40918 5 7.61832 5 5.40918C5 3.20004 6.79086 1.40918 9 1.40918ZM9 3.40918C7.89543 3.40918 7 4.30461 7 5.40918C7 6.51375 7.89543 7.40918 9 7.40918C10.1046 7.40918 11 6.51375 11 5.40918C11 4.30461 10.1046 3.40918 9 3.40918ZM9 10.4092C11.67 10.4092 17 11.7392 17 14.4092V17.4092H1V14.4092C1 11.7392 6.33 10.4092 9 10.4092ZM9 12.3092C6.03 12.3092 2.9 13.7692 2.9 14.4092V15.5092H15.1V14.4092C15.1 13.7692 11.97 12.3092 9 12.3092Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (User);


/***/ }),

/***/ 51024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 18px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("svg").withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "width"
        ].includes(prop);
    }
}).withConfig({
    componentId: "sc-2a94fc25-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function Web(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style), {
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.924 11.7473C12.996 11.1533 13.05 10.5593 13.05 9.94727C13.05 9.33527 12.996 8.74127 12.924 8.14727H15.966C16.11 8.72327 16.2 9.32627 16.2 9.94727C16.2 10.5683 16.11 11.1713 15.966 11.7473M11.331 16.7513C11.871 15.7523 12.285 14.6723 12.573 13.5473H15.228C14.364 15.0323 12.987 16.1843 11.331 16.7513ZM11.106 11.7473H6.894C6.804 11.1533 6.75 10.5593 6.75 9.94727C6.75 9.33527 6.804 8.73227 6.894 8.14727H11.106C11.187 8.73227 11.25 9.33527 11.25 9.94727C11.25 10.5593 11.187 11.1533 11.106 11.7473ZM9 17.1113C8.253 16.0313 7.65 14.8343 7.281 13.5473H10.719C10.35 14.8343 9.747 16.0313 9 17.1113ZM5.4 6.34727H2.772C3.627 4.85327 5.013 3.70127 6.66 3.14327C6.12 4.14227 5.715 5.22227 5.4 6.34727ZM2.772 13.5473H5.4C5.715 14.6723 6.12 15.7523 6.66 16.7513C5.013 16.1843 3.627 15.0323 2.772 13.5473ZM2.034 11.7473C1.89 11.1713 1.8 10.5683 1.8 9.94727C1.8 9.32627 1.89 8.72327 2.034 8.14727H5.076C5.004 8.74127 4.95 9.33527 4.95 9.94727C4.95 10.5593 5.004 11.1533 5.076 11.7473M9 2.77427C9.747 3.85427 10.35 5.06027 10.719 6.34727H7.281C7.65 5.06027 8.253 3.85427 9 2.77427ZM15.228 6.34727H12.573C12.285 5.22227 11.871 4.14227 11.331 3.14327C12.987 3.71027 14.364 4.85327 15.228 6.34727ZM9 0.947266C4.023 0.947266 0 4.99727 0 9.94727C0 12.3342 0.948212 14.6234 2.63604 16.3112C4.32387 17.9991 6.61305 18.9473 9 18.9473C13.9706 18.9473 18 14.9178 18 9.94727C18 7.56032 17.0518 5.27113 15.364 3.5833C13.6761 1.89548 11.3869 0.947266 9 0.947266Z",
            fill: "currentColor"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Web);


/***/ }),

/***/ 26227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  width: 100%;\n  min-height: 20px;\n  align-items: baseline;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var WrapError = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e3e9f45f-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function InputError(param) {
    var value = param.value, meta = param.meta, languageCode = param.languageCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapError, {
        fontSize: "pSmall",
        lineHeight: "pSmall",
        fontWeight: "normal",
        color: "red_400",
        children: meta.error && (meta.touched || value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
            children: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode][meta.error] || meta.error
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InputError);


/***/ }),

/***/ 18744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68863);
/* harmony import */ var theme_icons_check_circle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53107);
/* harmony import */ var theme_icons_alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88176);
/* harmony import */ var theme_icons_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39024);
/* harmony import */ var theme_input_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26227);
/* eslint-disable no-nested-ternary */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  outline: 0;\n\n  .ant-input {\n    appearance: none;\n    margin: 0;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: relative;\n    display: inline-block;\n    color: ",
        ";\n    font-size: 16px;\n    line-height: 1.5715;\n    background-color: ",
        ";\n    background-image: none;\n    box-shadow: none;\n    transition: all 0.3s;\n    width: 100%;\n    height: 38px;\n    border: 2px solid;\n    border-color: ",
        ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    padding: 0 ",
        "px;\n    padding-right: ",
        "px;\n\n    :hover {\n      border-color: ",
        ";\n    }\n\n    :focus {\n      border-color: ",
        ";\n    }\n\n    :disabled {\n      opacity: 0.5;\n    }\n\n    :placeholder-shown {\n      text-overflow: ellipsis;\n    }\n  }\n\n  .ant-input-affix-wrapper,\n  .ant-input-group {\n    position: relative;\n  }\n\n  .ant-input-suffix {\n    position: absolute;\n    right: ",
        "px;\n    top: 0px;\n    bottom: 0px;\n\n    .ant-input-password-icon {\n      color: ",
        ";\n\n      & > svg {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .ant-input-group-addon {\n    position: absolute;\n    right: ",
        "px;\n    top: 0px;\n    bottom: 0px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 18px;\n  height: 18px;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .keyframes */ .F4)(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3855b535-0"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.grey_400"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.white"), function(param) {
    var meta = param.meta;
    return meta.error && meta.touched ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.red_400") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_100");
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), function(param) {
    var addonAfter = param.addonAfter;
    return addonAfter ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.l") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s");
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_200"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_500"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.grey_600"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), function(param) {
    var meta = param.meta;
    return !meta.touched ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.grey_600") : meta.error ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.red_400") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400");
});
var WrapLoader = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3855b535-1"
})(_templateObject2(), rotate);
function CustomInput(param) {
    var className = param.className, noError = param.noError, addonAfter = param.addonAfter, autoComplete = param.autoComplete, disabled = param.disabled, input = param.input, meta = param.meta, placeholder = param.placeholder, style = param.style, isWaiting = param.isWaiting, languageCode = param.languageCode;
    var inputIcon = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (!addonAfter) return "";
        if (isWaiting) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapLoader, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    width: 18
                })
            });
        }
        if (!meta.touched) return "";
        return meta.error && meta.touched ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_alert__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_check_circle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
    }, [
        addonAfter,
        isWaiting,
        meta
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        addonAfter: addonAfter,
        fontSize: "display",
        lineHeight: "display",
        fontWeight: "normal",
        meta: meta
    }, style), {
        className: className,
        children: [
            input.type === "password" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Password */ .Z.Password, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, input), {
                placeholder: placeholder,
                disabled: disabled,
                autoComplete: autoComplete
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, input), {
                autoComplete: autoComplete,
                placeholder: placeholder,
                disabled: disabled,
                addonAfter: inputIcon
            })),
            !noError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_input_error__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                value: input.value,
                meta: meta,
                languageCode: languageCode || "en"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomInput);


/***/ }),

/***/ 23856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15313);
/* harmony import */ var theme_layouts_body__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89129);
/* harmony import */ var theme_card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16850);
/* harmony import */ var theme_logo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12648);
/* harmony import */ var theme_icons_loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39024);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99408);
/* harmony import */ var theme_buttons_btn_border__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9246);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  width: 100%;\n  min-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  width: 40px;\n  height: 40px;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .keyframes */ .F4)(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6aaa7b7e-0"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .flexbox */ .GQ, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
var Text = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-6aaa7b7e-1"
})(_templateObject2(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
var Box = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6aaa7b7e-2"
})(_templateObject3());
var WrapLoader = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6aaa7b7e-3"
})(_templateObject4(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, rotate);
function LoaderComp(param) {
    var authState = param.authState;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loaded = ref[0], setLoaded = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var timeOut;
        window.addEventListener("load", function() {
            timeOut = setTimeout(function() {
                setLoaded(true);
            }, 10000); // Wait 10 seconds before showing the button
        });
        return function() {
            clearTimeout(timeOut);
        };
    }, []);
    var handleRefresh = function() {
        caches.keys().then(function(cacheNames) {
            cacheNames.forEach(function(cacheName) {
                caches.delete(cacheName);
            });
        });
        var timestamp = new Date().getTime();
        var url = window.location.href;
        var urlWithTimestamp = "".concat(url, "?timestamp=").concat(timestamp);
        // Esegui la ricarica forzata
        window.location.href = urlWithTimestamp;
    };
    var currentDomain =  true ? window.location.hostname : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        justifyContent: [
            "space-between",
            "space-between",
            "flex-start"
        ],
        px: "l",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_layouts_body__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bg: "primary_400"
            }),
            currentDomain.match(/bookrix.de/i) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    margin: "20px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/images/bookrix_logo_ext.png",
                    width: "300",
                    height: 87,
                    alt: "Logo BookRix"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_logo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                height: 48,
                style: {
                    color: "white",
                    height: "48px",
                    my: "xxl"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                width: "100%",
                maxWidth: "420px",
                bg: "white",
                border: "none",
                px: "m",
                py: "l",
                my: "xxl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Box, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapLoader, {
                            color: "primary_400",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_loader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                            fontSize: "h4",
                            lineHeight: "h4",
                            fontWeight: "bold",
                            color: "grey_600",
                            mt: "s",
                            children: translations__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z[languageCode]["wait a few seconds"]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Text, {
                            fontSize: "pSmall",
                            lineHeight: "pSmall",
                            fontWeight: "normal",
                            color: "grey_600",
                            mt: "s",
                            children: [
                                translations__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z[languageCode]["Do you want to switch user?"],
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    href: currentDomain.match(/bookrix.de/i) ? "https:".concat("//auth.bookrix.de/signout") : "https:".concat("//auth.streetlib.com/signout"),
                                    children: translations__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z[languageCode]["Sign Out"]
                                })
                            ]
                        }),
                        loaded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_border__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            style: {
                                p: 2,
                                mt: "20px",
                                color: "primary_300"
                            },
                            onClick: handleRefresh,
                            label: translations__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z[languageCode]["Reload browser cache"]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (LoaderComp);


/***/ }),

/***/ 75436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5799);
/* harmony import */ var theme_buttons_btn_user_menu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73909);
/* harmony import */ var theme_icons_close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5842);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  body {\n    overflow-y: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: ",
        ";\n  justify-content: center;\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(6, 119, 134, 0.6);\n  z-index: 999;\n\n  & > div {\n    padding: ",
        "px 0;\n\n    ::-webkit-scrollbar {\n      display: none; /* Chrome Safari */\n    }\n\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE 10+ */\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n\n  border-radius: 12px;\n  overflow: hidden;\n\n  & > .head {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    background: ",
        ";\n    height: 86px;\n    padding: 0 ",
        "px;\n\n    & > div:first-child {\n      flex: 1;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n    }\n  }\n\n  & > .body {\n    display: flex;\n    flex-direction: row;\n    padding: ",
        "px;\n\n    ",
        "\n\n    & > div:first-child {\n      margin-left: 0;\n    }\n  }\n\n  & > .footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding-bottom: ",
        "px;\n\n    & > a {\n      text-decoration: none;\n      cursor: pointer;\n      color: ",
        ";\n\n      & > :hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .createGlobalStyle */ .vJ)(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3c986b8-0"
})(_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "flex" : "none";
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.xxl"));
var Content = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3c986b8-1"
})(_templateObject2(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.white"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.m"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_300"));
function CustomModal(param) {
    var contentStyle = param.contentStyle, width = param.width, bgColor = param.bgColor, style = param.style, isVisible = param.isVisible, onClose = param.onClose, title = param.title, children = param.children, footer = param.footer;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, style), {
        isVisible: isVisible,
        children: [
            isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    width: width || "800px",
                    bg: bgColor || "primary_50"
                }, contentStyle), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "head",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        fontSize: "h1",
                                        lineHeight: "h1",
                                        fontWeight: "bold",
                                        color: "grey_600",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_user_menu__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    type: "button",
                                    style: {
                                        width: "38px",
                                        height: "38px",
                                        mr: "xs"
                                    },
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "body",
                            children: children
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "footer",
                            children: footer
                        })
                    ]
                }))
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomModal);


/***/ })

}]);